"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_html_parser_1 = require("react-html-parser");
var journey_model_1 = require("@athena-portal/journey-model");
var journey_services_1 = require("@athena-portal/journey-services");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var reactstrap_1 = require("reactstrap");
var services_1 = require("@falcon/services");
var ModalWidget = /** @class */ (function (_super) {
    __extends(ModalWidget, _super);
    function ModalWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.render = function () {
            var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: _this.toggle });
            return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { id: _this.props.question.name, className: "my-2 info-modal", isOpen: _this.state.isOpen, toggle: _this.toggle, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { toggle: _this.toggle, close: closeBtn, children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [_this.renderIcon(), (0, jsx_runtime_1.jsx)("div", { className: "text-blue-2 font-weight-medium", children: _this.renderHtml(_this.title) })] }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalBody, { children: (0, jsx_runtime_1.jsx)("div", { className: "font-weight-light", children: _this.renderHtml(_this.bodyHtml) }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalFooter, { className: "d-flex", onClick: _this.modalAction, children: _this.renderFooter() })] }));
        };
        _this.renderHtml = function (htmlText) {
            return (0, react_html_parser_1.default)(_this.renderTemplate(htmlText, true), {
                transform: function (node) {
                    if (node.name === 'script' || node.name === 'style' || node.name === 'link') {
                        return null;
                    }
                    return;
                }
            });
        };
        _this.renderTemplate = function (template, escapeFields) {
            return journey_services_1.ExpressionEvaluator.renderTemplate(template, _this.props.interaction, escapeFields);
        };
        _this.toggle = function () {
            _this.executeEvent("blur");
            _this.setState(function (state) { return ({
                isOpen: !state.isOpen
            }); });
        };
        _this.toggleChange = function () {
            _this.executeEvent("change");
            _this.setState(function (state) { return ({
                isOpen: !state.isOpen
            }); });
        };
        _this.renderIcon = function () {
            switch (_this.modalType) {
                case "info":
                    return (0, jsx_runtime_1.jsx)("img", { className: "d-block mr-3 mb-1 info-icon-selected", src: "/img/Flow-info-selected.svg" });
                case "alert":
                    return (0, jsx_runtime_1.jsx)("img", { className: "d-block mr-3 mb-1 fixed-alert-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-blue.svg") });
                case "recycle":
                    return (0, jsx_runtime_1.jsx)("img", { className: "d-block mr-3 mb-1", src: "/img/recycle-icon.png" });
                default:
                    throw new Error("".concat(_this.props.question.type, " widget has incorrectly set 'modalType' setting: '").concat(_this.modalType, "' is unknown"));
            }
        };
        _this.modalAction = function (event) {
            var action = event.target.dataset.modalAction;
            if (action === "close-modal") {
                _this.toggle();
            }
            if (action === "change-and-close") {
                _this.toggleChange();
            }
        };
        _this.renderFooter = function () {
            if (!_this.footerHtml) {
                return ((0, jsx_runtime_1.jsx)("button", { "data-modal-action": "close-modal", type: "button", className: "btn btn-primary btn-add width-md-250 mb-1", children: "Ok, I understand" }));
            }
            return _this.renderHtml(_this.footerHtml);
        };
        _this.modalType = _this.getSetting("modalType");
        if (!_this.modalType) {
            throw new Error("Widget ".concat(_this.props.question.type, " (").concat(_this.props.question.name, ") missing 'modalType' setting"));
        }
        _this.title = _this.getSetting("title");
        if (!_this.title) {
            throw new Error("Widget ".concat(_this.props.question.type, " (").concat(_this.props.question.name, ") missing 'title' setting"));
        }
        _this.bodyHtml = _this.getSetting("bodyHtml");
        if (!_this.bodyHtml) {
            throw new Error("Widget ".concat(_this.props.question.type, " (").concat(_this.props.question.name, ") missing 'bodyHtml' setting"));
        }
        _this.footerHtml = _this.getSetting("footerHtml");
        _this.state = {
            isOpen: true,
            interactionFieldValue: undefined
        };
        return _this;
    }
    ModalWidget.prototype.componentDidUpdate = function () {
        var relatedInteractionField = this.getSetting("relatedInteractionField");
        if (relatedInteractionField) {
            var fieldValue = journey_services_1.ObjectManipulator.fetchFieldValue(relatedInteractionField, this.props.interaction);
            if (fieldValue !== this.state.interactionFieldValue) {
                this.setState({
                    interactionFieldValue: fieldValue,
                    isOpen: true
                });
            }
        }
    };
    ModalWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "modalType", type: journey_model_1.TypeDescriptions.String },
            { name: "title", type: journey_model_1.TypeDescriptions.String },
            { name: "bodyHtml", type: journey_model_1.TypeDescriptions.String },
            { name: "footerHtml", type: journey_model_1.TypeDescriptions.String },
            { name: "relatedInteractionField", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], ModalWidget);
    return ModalWidget;
}(plugin_journey_1.WidgetBase));
exports.ModalWidget = ModalWidget;
//# sourceMappingURL=ModalWidget.js.map